import { EVENT_MANAGER_PLUGINS } from '@angular/platform-browser';
import { PreventDefaultEventPlugin } from './prevent-default.event-plugin';

export const provideCustomEventPlugins = () => [
  {
    provide: EVENT_MANAGER_PLUGINS,
    multi: true,
    useClass: PreventDefaultEventPlugin,
  },
];
